import {Component, OnDestroy, OnInit, Optional} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {allowedLanguages} from 'src/app/app.component';
import {Language} from 'src/app/features/user/user.data.service';
import {ExtractedTopic} from '../../e-learning.selectors';
import {TopicFilterStore} from './topic-filter.store';
import {MatDialogRef} from '@angular/material/dialog';

/**
 * TODO: With the changes in the redesign and the subsequent simplification of this component and it's UX-flow,
 *  we can probably simplify this whole thing to not rely on a component store but instead take a list of topics (via e.g. a service)
 *  and emit the selections on close.
 */
@Component({
  selector: 'app-topic-filter',
  templateUrl: './topic-filter.component.html',
  styleUrls: ['./topic-filter.component.scss'],
})
export class TopicFilterComponent implements OnInit, OnDestroy {
  readonly topics$ = this._componentStore.mappedTopics$;
  readonly languages: ('all' | Language)[] = ['all', ...allowedLanguages];

  selectedLanguage: 'all' | Language = 'all';

  private readonly _subscription = new Subscription();

  constructor(
    private readonly _componentStore: TopicFilterStore,
    private readonly _translate: TranslateService,
    @Optional() private readonly _dialogRef?: MatDialogRef<TopicFilterComponent>,
  ) {}

  ngOnInit(): void {
    this._subscription.add(
      this._componentStore.languageSelection$.pipe(distinctUntilChanged()).subscribe((select) => {
        if (!!select) this.selectedLanguage = select;
        else this.selectedLanguage = 'all';
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  toggleFilterSelection(id: string) {
    this._componentStore.toggleSelectTopic(id);
  }

  getTopicTitle(topic: ExtractedTopic) {
    // TODO: this is just a duplicate, make a unDRY-solution for this!
    if (topic.generated && topic.title_en) {
      // in case this is generated, use the translator, as the title is set in the translations-file
      // indifferent whether de- or en-field is used, both contain the key in this case
      return this._translate.instant(topic.title_en);
    }
    // otherwise, the BE already delivers a translated title in the fields
    return this._translate.currentLang === 'de' ? topic.title_de : topic.title_en;
  }

  selectAllTopics() {
    this._componentStore.setAllTopics(true);
  }

  deselectAllTopics() {
    this._componentStore.setAllTopics(false);
  }

  selectLanguage(lang: 'all' | Language) {
    if (lang === 'all') {
      this._componentStore.setLanguageSelection(null);
    } else {
      this._componentStore.setLanguageSelection(lang);
    }
  }

  close() {
    // Close the dialog if opened as a MatDialog
    this._dialogRef?.close();
  }
}
